<template>
  <div class="tabbar">
    <van-tabbar v-model="active" @change="handleChange">
      <van-tabbar-item name="home" to="/">
        <template #icon="{ active }">
          <!-- <span class="material-icons">
            house
          </span> -->
          <svg t="1778140855888" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="11279" width=".6rem" height=".6rem">
            <path :fill="active ? '#fff' : '#ADADAD'"
              d="M147.904 304.128l301.866667-179.541333a128 128 0 0 1 131.712 0.512l295.466666 178.88A128 128 0 0 1 938.666667 413.482667V810.666667a128 128 0 0 1-128 128H213.333333a128 128 0 0 1-128-128V414.144a128 128 0 0 1 62.570667-110.016z m43.626667 73.344A42.666667 42.666667 0 0 0 170.666667 414.144V810.666667a42.666667 42.666667 0 0 0 42.666666 42.666666h597.333334a42.666667 42.666667 0 0 0 42.666666-42.666666V413.482667a42.666667 42.666667 0 0 0-20.565333-36.501334l-295.466667-178.88a42.666667 42.666667 0 0 0-43.925333-0.170666l-301.866667 179.541333z"
              p-id="11280"></path>
            <path
              d="M405.333333 469.333333h213.333334a42.666667 42.666667 0 1 1 0 85.333334H405.333333a42.666667 42.666667 0 1 1 0-85.333334z m0 85.333334a42.666667 42.666667 0 1 0 0-85.333334h213.333334a42.666667 42.666667 0 1 0 0 85.333334H405.333333z"
              p-id="11281" :fill="active ? '#fff' : '#ADADAD'"></path>
          </svg>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="order" to="/order">
        <template #icon="{ active }">
          <!-- <span class="material-icons">
            list_alt
          </span> -->
          <svg t="1778141020072" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="20198" width=".6rem" height=".6rem">
            <path :fill="active ? '#fff' : '#ADADAD'"
              d="M821.333333 256a32 32 0 0 1 64 0v565.333333c0 64.8-52.533333 117.333333-117.333333 117.333334H256c-64.8 0-117.333333-52.533333-117.333333-117.333334V202.666667c0-64.8 52.533333-117.333333 117.333333-117.333334h597.333333a32 32 0 0 1 0 64H256a53.333333 53.333333 0 0 0-53.333333 53.333334v618.666666a53.333333 53.333333 0 0 0 53.333333 53.333334h512a53.333333 53.333333 0 0 0 53.333333-53.333334V256zM341.333333 437.333333a32 32 0 0 1 0-64h341.333334a32 32 0 0 1 0 64H341.333333z m0 170.666667a32 32 0 0 1 0-64h213.333334a32 32 0 0 1 0 64H341.333333z"
              p-id="20199"></path>
          </svg>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="goOrder" to="/goOrder">
        <template #icon="{ active }">
          <!-- <span class="material-icons">
            touch_app
          </span> -->
          <svg t="1778140545654" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="1660" width=".6rem" height=".6rem">
            <path :fill="active ? '#fff' : '#ADADAD'"
              d="M265.216 967.68c-7.68 0-15.36-3.072-21.504-8.704-10.24-9.728-12.288-25.088-5.632-37.888l171.008-303.616-179.712-159.232c-6.656-5.632-10.24-13.824-10.24-22.528 0-8.704 3.584-16.896 9.728-23.04l363.008-347.648c9.728-9.216 24.576-11.264 36.864-4.608 11.776 6.656 17.92 20.48 15.36 33.792l-65.024 303.616 215.552 204.8c7.168 6.656 10.752 16.384 9.728 25.6-1.024 9.728-6.656 18.432-14.848 23.04l-117.76 72.192c-14.336 8.704-33.792 4.608-42.496-10.24-8.704-14.848-4.096-33.792 10.24-42.496l82.432-51.2-198.656-188.416c-7.68-7.68-11.264-18.432-9.216-29.184l47.616-221.696-265.728 253.952 173.056 153.6c10.752 9.728 13.824 25.6 6.656 38.4l-124.416 220.672 151.552-93.184c14.336-9.216 33.792-4.608 42.496 10.24 9.216 14.336 4.608 33.792-10.24 42.496L281.6 963.072c-5.12 3.072-10.752 4.608-16.384 4.608z m0 0"
              p-id="1661"></path>
          </svg>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="serve" to="/serve">
        <template #icon="{ active }">
          <!-- <span class="material-icons">
            support_agent
          </span> -->

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width=".6rem" height=".6rem"
            :fill="active ? '#fff' : '#ADADAD'">
            <path
              d="M21 8C22.1046 8 23 8.89543 23 10V14C23 15.1046 22.1046 16 21 16H19.9381C19.446 19.9463 16.0796 23 12 23V21C15.3137 21 18 18.3137 18 15V9C18 5.68629 15.3137 3 12 3C8.68629 3 6 5.68629 6 9V16H3C1.89543 16 1 15.1046 1 14V10C1 8.89543 1.89543 8 3 8H4.06189C4.55399 4.05369 7.92038 1 12 1C16.0796 1 19.446 4.05369 19.9381 8H21ZM7.75944 15.7849L8.81958 14.0887C9.74161 14.6662 10.8318 15 12 15C13.1682 15 14.2584 14.6662 15.1804 14.0887L16.2406 15.7849C15.0112 16.5549 13.5576 17 12 17C10.4424 17 8.98882 16.5549 7.75944 15.7849Z">
            </path>
          </svg>
        </template>
      </van-tabbar-item>
      <van-tabbar-item name="user" to="/user">
        <template #icon="{ active }">
          <!-- <span class="material-icons">
            account_circle
          </span> -->
          <svg t="1778140739108" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
            p-id="7718" width=".56rem" height=".56rem">
            <path :fill="active ? '#fff' : '#ADADAD'"
              d="M691.2 608c-57.4 0-85 32-179.2 32-94.2 0-121.6-32-179.2-32C184.4 608 64 728.4 64 876.8V928c0 53 43 96 96 96h704c53 0 96-43 96-96v-51.2c0-148.4-120.4-268.8-268.8-268.8zM864 928H160v-51.2c0-95.2 77.6-172.8 172.8-172.8 29.2 0 76.6 32 179.2 32 103.4 0 149.8-32 179.2-32 95.2 0 172.8 77.6 172.8 172.8V928zM512 576c159 0 288-129 288-288S671 0 512 0 224 129 224 288s129 288 288 288z m0-480c105.8 0 192 86.2 192 192s-86.2 192-192 192-192-86.2-192-192 86.2-192 192-192z"
              p-id="7719"></path>
          </svg>
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 'home'
    };
  },
  methods: {
    handleChange(name) {
      this.active = name;
      localStorage.setItem('home', name)
    },
    toServe() {
      window.location.href = 'https://www.baidu.com'
    }
  },
  created() {
    if (localStorage.getItem('home')) {
      this.active = localStorage.getItem('home')
    }
    this.active = this.$route.name;
  },
  watch: {
    '$route.path'(to, from) {
      if (to === '/') {
        this.active = 'home';
      }
      if (to === '/order') {
        this.active = 'order';
      }
      if (to === '/goOrder') {
        this.active = 'goOrder';
      }
      if (to === '/serve') {
        this.active = 'serve';
      }
      if (to === '/user') {
        this.active = 'user';
      }
    }
  }
};
</script>

<style lang="less" scoped>
.tabbar {
  position: fixed;
  bottom: 0;
  font-family: Rubik-Medium, Rubik;
}

.iconfont {
  font-size: 23px;
}

.color {
  color: #43a8ff;
}

.colors {
  color: #a19fa8;
}

.color2 {
  font-size: 44px;
  color: #43a8ff;
  background-color: #fff;
  border-radius: 50%;
  padding: 3px;
  padding-bottom: 0;
}

::v-deep {
  .van-tabbar {
    left: auto;
    max-width: 560PX;
    height: 1.4rem;
    padding: 5px 0;
    backdrop-filter: saturate(100%) blur(.25rem);
    box-shadow: 0px 0px .25rem 0px rgb(255 255 255 / 10%);
    z-index: 500;
    background-color: #333;
    box-sizing: border-box;
  }


  .van-tabbar-item--active {
    background-color: transparent;

    .material-icons {
      color: #eee;
    }
  }

  .material-icons {
    color: #bbb;
    font-size: .56rem;
  }

  .van-tabbar-item__text {
    font-size: 14px;
    text-align: center;

    span {
      color: #000;
    }
  }

  .van-hairline--top-bottom::after {
    border: 0;
  }
}
</style>
